/**
 * Get parameter by name, got it from https://stackoverflow.com/a/901144/5449101
 * @param name
 * @param url
 * @returns {string|null}
 */
export const getParameterByName = (name, url) => {
	if (!url) url = window.location.href;
	// eslint-disable-next-line no-useless-escape
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
